import {Injectable, Pipe, PipeTransform} from '@angular/core';

@Pipe({
    name: 'musicStyle',
    standalone: false
})
@Injectable({providedIn: 'root'})
export class MusicStylePipe implements PipeTransform {
  transform(musicStyle: string): string {
    const styles: {[key: string]: string} = {
      music_dutch: 'Dutch',
      music_punk: 'Punk',
      music_urban_r_b: 'Urban/R&B',
      music_blues: 'Blues',
      music_jazz: 'Jazz',
      music_hardrock: 'Hardrock',
      music_heavy_metal: 'Heavy metal',
      music_electronic_dance_music: 'EDM',
      music_hardstyle: 'Hardstyle',
      music_dubstep: 'Dubstep',
      music_techno: 'Techno',
      music_pop: 'Pop',
      music_drum_bass: 'Drum bass',
      music_latin: 'Latin',
      music_latin_house: 'Latin House',
      music_french: 'French',
      music_trance: 'Trance',
      music_hardcore: 'Hardcore',
      music_german: 'German',
      music_bubbling: 'Bubbling',
      music_soul: 'Soul',
      music_commercial_rock: 'Commercial Rock',
      music_house: 'House',
      music_raggea: 'Raggea',
      music_90_s_classics: '90s Classics',
      music_commercial_dance: 'Commercial Dance',
      music_lounge: 'Lounge',
      music_progressive_house: 'Progressive house',
      music_elektro_house: 'Electro house',
      music_funk: 'Funk',
      music_classixs: 'Classics',
      music_hip_hop_rap: 'Rap',
      music_tech_house: 'Tech house',
      music_minimal: 'Minimal',
      music_deep_house: 'Deep house',
      music_salsa: 'Salsa',
      music_classical_opera: 'Classical',
      music_freestyle: 'Freestyle',
      music_indie: 'Indie',
      music_gospel: 'Gospel',
      music_future_house: 'Future house',
      music_tropical_house: 'Tropical house',
      music_samba: 'Samba',
      music_eclectic: 'Eclectic',
      music_disco: 'Disco',
    };

    if (!styles[musicStyle]) {
      return musicStyle;
    }

    return styles[musicStyle];
  }
}
